<script>
import RawData from "@/components/widgets/raw-data.vue";
import PostButton from '@/components/widgets/finance-post-btn.vue'
export default {
    name: "DisbursementList",
    components: {
        RawData,
        PostButton
    },
    props: {
        type: {
            type: String,
            default: "available",
        },
        tableData: {
            type: Array,
            default: () => [],
        },
        loading: {
            type: Boolean,
            default: false,
        },
        journals: {
            type: Array,
            default: () => [],
        }
    },
    computed: {
        filtered() {
            let data = this.tableData;
            if (this.filter && this.filter.trim() != "") {
                data = data.filter((item) => {
                    return item.filterKey
                        .toUpperCase()
                        .includes(this.filter.toUpperCase());
                });
            }
            var total = this.currentPage * this.perPage;
            var currentData = data.slice(total - this.perPage, total);
            if (this.currentPage > 1 && currentData.length == 0) {
                total = (this.currentPage - 1) * this.perPage;
                currentData = data.slice(total - this.perPage, total);
            }
            return currentData;
        },
        rows() {
            let data = this.tableData;
            if (this.filter && this.filter.trim() != "") {
                data = data.filter((item) => {
                    return item.filterKey
                        .toUpperCase()
                        .includes(this.filter.toUpperCase());
                });
            }
            return data.length;
        },
        selectedBurs() {
            return this.tableData.filter(item => item.selected);
        }
    },
    data() {
        return {
            filter: null,
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
            selection: false
        }
    },
    methods: {
        getDisbursementDetails(item) {
            item.opened = !item.opened;
        },
        formatText(text) {
            return text.replace(/(?:\r\n|\r|\n)/g, "<br>");
        },
        generateDV(item) {
            this.$emit("generateDV", item);
        },
        postNow(form, data) {
            this.$emit("post", { form, data });
        },
        editDisbursement(item) {
            this.$emit("editDisbursement", item);
        },
        returnDisbursement(item) {
            this.$emit("returnDisbursement", item);
        },
        deleteDisbursement(item) {
            this.$emit("deleteDisbursement", item);
        },
        getTotalDebit(items) {
            return items.reduce((total, item) => {
                return total + ( item.isDebit ? item.amount : 0);
            }, 0);
        },
        getTotalCredit(items) {
            return items.reduce((total, item) => {
                return total + (!item.isDebit ? item.amount : 0);
            }, 0);
        },
        updateRelease(dv) {
            this.$emit("updateRelease", dv);
        },
    }
}
</script>
<template>
    <div class="disbursement-list">
        <div class="d-flex justify-content-between align-items-center mb-2" v-if="!loading && tableData.length">
            <label class="d-inline-flex align-items-center">
                <b-form-input
                    autocomplete="off"
                    v-model="filter"
                    type="search"
                    placeholder="Search..."
                    class="form-control me-2"
                ></b-form-input>
                <b-form-select
                    class="form-select w-25"
                    v-model="perPage"
                    :options="pageOptions"
                ></b-form-select>
            </label>
        </div>
        <template v-if="loading">
            <b-skeleton width="100%" height="50px" class="bg-primary bg-soft mb-2" v-for="x in 5" :key="x"></b-skeleton>
        </template>
        <template v-if="!loading && !tableData.length">
            <div class="text-center mt-5 pt-5">
                <h4 class="text-muted">No data available</h4>
            </div>
        </template>
        <template v-if="!loading && tableData.length">
            <template v-for="(x, index) in filtered">
                <div class="d-flex align-items-center" :key="`A${index}`" >
                    <div
                        v-if="selection"
                        class="
                            form-check
                            form-checkbox-outline
                            form-check-success
                        "
                    >
                        <input
                            type="checkbox"
                            :id="`checkbox-${index}`"
                            class="form-check-input"
                            v-model="x.selected"
                        />
                    </div>
                    <div
                        role="tablist"
                        :key="`B-${type}-${index}`"
                        class="w-100"
                    >
                        <b-card
                            no-body
                            class="mb-2 shadow-none border"
                            :style="{
                                'z-index': `${filtered.length - index}`,
                            }"
                        >
                            <RawData :data="x" v-if="$store.state.decrypt.isAdmin()" placement="left" :keyId="`exT-${type}-${x.id}`"/>
                            <b-card-header
                                header-tag="header"
                                role="tab"
                                header-class="cursor-pointer hover-header"
                                :class="{'border-bottom': x.opened}"
                                
                            >
                                <div
                                    class="
                                        d-flex
                                        justify-content-between
                                        align-items-center
                                    "
                                >
                                    <div>
                                        <div class="mb-1">
                                            <a class="text-dark hover-underline" href="javascript: void(0);" @click="getDisbursementDetails(x)">
                                                <span class="text-info">[{{ x.disbursementNumber}}]</span>:
                                                &nbsp;
                                                <span class="font-weight-bold text-white">{{ x.particulars }}</span>
                                            </a>
                                        </div>
                                        <h6 class="mb-0 line-height-1 text-warning" @click="getDisbursementDetails(x)">Amount: {{formatCurrency(x.amount)}} </h6>
                                    </div>
                                    <div class="d-flex align-items-center" @click="getDisbursementDetails(x)">
                                        <div>
                                            <span class="d-flex align-items-center">
                                                <small v-if="!x.opened">Click here to show more details</small><i
                                                    class="bx bx-chevron-right rotate font-size-18 ms-3"
                                                    :class="{'rotate-90': x.opened }"
                                                ></i
                                            ></span>
                                        </div>
                                    </div>
                                </div>
                            </b-card-header>
                            <b-collapse
                                :visible="x.opened"
                                :accordion="`${type}-accordion-${x.id}`"
                                role="tabpanel"
                            >
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-md-6 border-end">
                                            <div class="py-2">
                                                <table class="w-100">
                                                    <tr>
                                                        <td class="px-2">DV Number:</td>
                                                        <td class="px-2"><strong>{{x.disbursementNumber}}</strong></td>
                                                    </tr>
                                                    <tr>
                                                        <td class="px-2">Mode of Payment:</td>
                                                        <td class="px-2"><strong>{{x.modeOfPayment}}</strong></td>
                                                    </tr>
                                                    <template v-if="x.modeOfPayment == 'Check'">
                                                        <tr>
                                                            <td class="px-2">Account Number:</td>
                                                            <td class="px-2"><strong>{{x.accountNumber}}</strong></td>
                                                        </tr>
                                                        <tr>
                                                            <td class="px-2">Bank:</td>
                                                            <td class="px-2"><strong>{{x.bank}}</strong></td>
                                                        </tr>
                                                        <tr>
                                                            <td class="px-2">Check Number:</td>
                                                            <td class="px-2"><strong>{{x.checkNumber}}</strong></td>
                                                        </tr>
                                                        <tr>
                                                            <td class="px-2">Check Date:</td>
                                                            <td class="px-2"><strong>{{formatDateShort(new Date(x.checkDate))}}</strong></td>
                                                        </tr>
                                                    </template>
                                                    <tr>
                                                        <td class="px-2">Disbursement Date:</td>
                                                        <td class="px-2"><strong v-if="x.disbursementDate">{{formatDateShort(new Date(x.disbursementDate))}}</strong></td>
                                                    </tr>
                                                    <tr>
                                                        <td class="px-2">Particulars:</td>
                                                        <td class="px-2"><strong>{{x.particulars}}</strong></td>
                                                    </tr>
                                                    <tr>
                                                        <td class="px-2 pb-3 align-top">Computations:</td>
                                                        <td class="px-2 pb-3"><span v-html="formatText(x.computations || '-')"></span></td>
                                                    </tr>
                                                    <template v-if="type == 'unreleased' || type == 'for-release'">
                                                        <tr>
                                                            <td colspan="2">
                                                                <div class="py-2 border rounded bg-info bg-soft px-2">
                                                                    Release Details:
                                                                    <table class="w-100">
                                                                        <tr>
                                                                            <td class="px-2" >Payee O.R Number:</td>
                                                                            <td class="px-2"><strong>{{x.payeeORNumber ? x.payeeORNumber : '-'}}</strong></td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td class="px-2" >Payee O.R Date:</td>
                                                                            <td class="px-2"><strong>{{x.payeeORDate && x.payeeORDate !== '0001-01-01T00:00:00' ? formatDateShort(new Date(x.payeeORDate)) : '-'}}</strong></td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td class="px-2" >Released Date:</td>
                                                                            <td class="px-2"><strong>{{x.isRelease ? formatDateShort(new Date(x.dateReleased)) : '-'}}</strong></td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td class="px-2" >Received By:</td>
                                                                            <td class="px-2"><strong>{{x.receivedBy || '-'}}</strong></td>
                                                                        </tr>
                                                                        <tr v-if="!x.isRelease">
                                                                            <td colspan="2" class="pt-3">
                                                                                <button class="btn btn-block btn-outline-info" @click="updateRelease(x)">Update Release Details</button>
                                                                            </td>
                                                                        </tr>
                                                                    </table>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    </template>
                                                </table>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="text-right font-size-16">
                                                Total Amount: <span class="text-white font-weight-bold">{{formatCurrency(x.amount)}}</span><br />
                                            </div>
                                            <span>Disbursement Items:</span>
                                            <table class="table table-sm align-middle table-bordered border-primary mb-0">
                                                <thead>
                                                    <tr>
                                                        <th>Account Name</th>
                                                        <th class="text-center"  style="width:150px;">Debit</th>
                                                        <th class="text-center"  style="width:150px;">Credit</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr
                                                        v-for="(item, index) in x.disbursementItems"
                                                        :key="index"
                                                    >
                                                        <td class="col-md-4">
                                                            <p class="font-size-12 mb-0">{{ item.account }}</p>
                                                        </td>
                                                        <td class="text-center">
                                                            {{item.isDebit ? formatCurrency(item.amount) : '-'}}
                                                        </td>
                                                        <td class="text-center">
                                                            {{!item.isDebit ? formatCurrency(item.amount) : '-'}}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>Total</td>
                                                        <td class="text-center">{{ formatCurrency(getTotalDebit(x.disbursementItems)) }}</td>
                                                        <td class="text-center">{{ formatCurrency(getTotalCredit(x.disbursementItems)) }}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <hr>
                                    <div class="d-flex justify-content-end gap-1 border-top pt-3 mt-2">
                                            <button type="buttton" class="btn btn-outline-info btn-rounded" @click="returnDisbursement(x)" v-if="type == 'posted'">
                                                <i class="bx bx-arrow-back"></i> Return DV
                                            </button>
                                            <button type="buttton" class="btn btn-outline-info btn-rounded" @click="editDisbursement(x)" v-if="type == 'submitted'">
                                                <i class="bx bx-edit"></i> Update DV
                                            </button>
                                            <button type="buttton" class="btn btn-outline-danger btn-rounded" @click="deleteDisbursement(x)" v-if="type == 'submitted'">
                                                <i class="bx bx-edit"></i> Remove DV
                                            </button>
                                            <button 
                                                type="buttton" 
                                                class="btn btn-outline-warning btn-rounded" 
                                                @click="$emit('attachment', {att: ['po', 'rfp', 'burs', 'dv'], id: x.id})"
                                            >
                                                <i class="bx bx-paperclip rotate rotate-45"></i> Attachments
                                            </button>
                                            <button type="buttton" class="btn btn-outline-purple btn-rounded" @click="$emit('generateDV', x)">
                                                <i class="bx bx-printer"></i> Generate DV
                                            </button>
                                            <PostButton 
                                                :data="x"
                                                @postNow="postNow($event, x)"
                                                v-if="type == 'submitted'"
                                                from="disbursement"
                                                buttonName="Approve"
                                            />
                                        </div>
                                </div>
                            </b-collapse>
                        </b-card>
                    </div>
                </div>
            </template>
            <div class="d-flex justify-content-end mt-2" v-if="tableData.length">
                <div class="dataTables_paginate paging_simple_numbers">
                    <ul class="pagination pagination-rounded mb-0">
                        <b-pagination
                            v-model="currentPage"
                            :total-rows="rows"
                            :per-page="perPage"
                        ></b-pagination>
                    </ul>
                </div>
            </div>
        </template>
    </div>
</template>